import React from 'react';
import { Modal, Form, Input, Select, InputNumber, Space, Button } from 'antd';
import { LegacyCoach } from '../../types';

const { Option } = Select;

interface CoachFormProps {
  visible: boolean;
  onCancel: () => void;
  onSubmit: (coachData: Partial<LegacyCoach>) => void;
  initialValues?: Partial<LegacyCoach>;
}

const CoachForm: React.FC<CoachFormProps> = ({
  visible,
  onCancel,
  onSubmit,
  initialValues
}) => {
  const [form] = Form.useForm();

  const handleSubmit = () => {
    form.validateFields().then(values => {
      onSubmit(values);
      form.resetFields();
    }).catch(error => {
      console.error('Form validation failed:', error);
    });
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title={initialValues ? 'Edit Coach' : 'Add New Coach'}
      open={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleSubmit}>
          {initialValues ? 'Update' : 'Create'}
        </Button>,
      ]}
      width={600}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialValues}
      >
        <Space direction="vertical" style={{ width: '100%' }} size="middle">
          <div style={{ display: 'flex', gap: 16 }}>
            <Form.Item
              name="firstName"
              label="First Name"
              rules={[{ required: true, message: 'Please enter first name' }]}
              style={{ flex: 1 }}
            >
              <Input placeholder="First name" />
            </Form.Item>
            
            <Form.Item
              name="lastName"
              label="Last Name"
              rules={[{ required: true, message: 'Please enter last name' }]}
              style={{ flex: 1 }}
            >
              <Input placeholder="Last name" />
            </Form.Item>
          </div>

          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: 'Please enter email' },
              { type: 'email', message: 'Please enter valid email' }
            ]}
          >
            <Input placeholder="Email address" />
          </Form.Item>

          <Form.Item
            name="phone"
            label="Phone Number"
            rules={[
              { required: true, message: 'Please enter phone number' },
              { pattern: /^[\+]?[1-9][\d]{0,15}$/, message: 'Please enter a valid phone number' }
            ]}
          >
            <Input placeholder="Enter phone number" />
          </Form.Item>

          <Form.Item
            name="specializations"
            label="Specializations"
          >
            <Select
              mode="multiple"
              placeholder="Select specializations"
            >
              <Option value="Strength Training">Strength Training</Option>
              <Option value="Weight Loss">Weight Loss</Option>
              <Option value="Yoga">Yoga</Option>
              <Option value="Athletic Performance">Athletic Performance</Option>
              <Option value="Sports Training">Sports Training</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="certifications"
            label="Certifications"
          >
            <Select
              mode="multiple"
              placeholder="Select certifications"
            >
              <Option value="NASM-CPT">NASM-CPT</Option>
              <Option value="ACSM">ACSM</Option>
              <Option value="NSCA-CSCS">NSCA-CSCS</Option>
              <Option value="RYT-200">RYT-200</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="salary"
            label="Salary"
            rules={[{ required: true, message: 'Please enter salary' }]}
          >
            <InputNumber
              placeholder="Annual salary"
              style={{ width: '100%' }}
              formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              parser={value => value!.replace(/\$\s?|(,*)/g, '')}
            />
          </Form.Item>

          <Form.Item
            name="notes"
            label="Notes"
          >
            <Input.TextArea rows={3} placeholder="Additional notes" />
          </Form.Item>
        </Space>
      </Form>
    </Modal>
  );
};

export default CoachForm; 